async function getCustomerOrdersHistory() {
	if (window.theme.customerStatus === 'not_logged_in_or_no_orders') return;

	const isInSessionStorage = sessionStorage.getItem('coh');
	const isOrderCountInSessionStorage = sessionStorage.getItem('cohn');

	if (
		isInSessionStorage &&
		isValidJSON(decodeURIComponent(escape(atob(isInSessionStorage)))) &&
		parseInt(isOrderCountInSessionStorage) === parseInt(window.theme.customersOrdersCount)
	) {
		const parsedData = JSON.parse(decodeURIComponent(escape(atob(isInSessionStorage))));
		window.theme.personalCabinet = [...parsedData];

		document.dispatchEvent(new CustomEvent('personal-cabinet:retrieved', { bubbles: true }));
	} else {
		const customerTotalOrders = window.theme.customersOrdersCount;
		const pagesBy20Orders = Math.ceil(customerTotalOrders / 20);
		const urlsToFetch = Array.from({ length: pagesBy20Orders }, (_, i) => `/account?view=api&page=${i + 1}`);
		const responses = await Promise.all(urlsToFetch.map((url) => fetch(url)));
		const data = await Promise.all(responses.map((response) => response.json()));
		const allOrders = data.flat();
		const allOrdersMapped = allOrders
			.map((order) => {
				return order.ordered_products;
			})
			.flat();
		const allProductsOrdered = allOrdersMapped
			.map((order) => {
				if (order.cancelled === 'true' || order.financial_status === 'refunded') {
					return [];
				} else {
					return order.products;
				}
			})
			.flat();

		const uniqueAllProductsOrdered = allProductsOrdered.filter(
			(product, index, self) => index === self.findIndex((t) => t.id === product.id)
		);

		const allOrderCountFromApi = allOrders[0].total_orders_number;
		const newSessionData = btoa(
			unescape(encodeURIComponent(JSON.stringify(uniqueAllProductsOrdered)).replace(/(?:\\[rn])+/g, ''))
		);
		sessionStorage.setItem('coh', newSessionData);
		sessionStorage.setItem('cohn', allOrderCountFromApi);

		window.theme.personalCabinet = [...uniqueAllProductsOrdered];
		document.dispatchEvent(new CustomEvent('personal-cabinet:retrieved', { bubbles: true }));
	}
}

function isValidJSON(str) {
	try {
		JSON.parse(str);
		return true;
	} catch (e) {
		return false;
	}
}

getCustomerOrdersHistory();
